import React from 'react';
import styled from 'styled-components';
import { primaryText } from 'styles/colors';
import Text from './Text';
import HasRole from './HasRole';
import { WRITE_ACCESS_AUTH_ROLES } from 'utils/appConstants';

const StyledButton = styled.button`
  height: ${({ buttonHeight }) => buttonHeight || '25px'};
  // Most buttons only require default padding
  // Example of button requiring more padding @ Login page
  padding: ${({ padding }) => padding || '0 10px'};
  border-radius: 4px;
  font-family: 'Crossten';
  font-weight: ${({ fontWeight }) => fontWeight || 600};
  font-size: ${({ fontSize }) => fontSize || '16px'};
  margin: ${({ margin }) => margin || 'none'};
  color: ${({ color }) => color || primaryText};
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: ${({ border }) => border || 'none'};
  background: ${({ background }) =>
    background || 'linear-gradient(180deg, #11b1d8 0%, #0779af 100%)'};
  text-decoration: none;
  box-sizing: border-box;
  outline: none;

  :hover {
    cursor: pointer;
  }

  a:visited {
    color: ${({ color }) => color || primaryText};
  }

  :disabled,
  [disabled] {
    background: #dcdcdc;
    color: gray;
    border: 1px solid gray;

    p {
      color: gray;
    }

    :hover {
      cursor: not-allowed;
    }
  }
`;

const Button = ({ children, ...props }) => {
  const { fontSize, color } = props;
  return (
    <StyledButton {...props}>
      <Text fontSize={fontSize} color={color}>
        {children}
      </Text>
    </StyledButton>
  );
};
export default Button;

export const BlueBorderButton = styled(Button)`
  background: #ffffff;
  border-radius: 4px;
  background-image: linear-gradient(white, white),
    linear-gradient(180deg, #11b1d8 0%, #0779af 100%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  border: ${({ isError }) =>
    isError ? '2px solid #EA6E6D' : '2px solid transparent'};

  p {
    font-size: 12px;
    color: ${({ isError, disabled }) =>
      isError ? '#EA6E6D' : disabled ? '#FFF' : '#0779af'};
  }

  :disabled {
    background: #dcdcdc;

    :hover {
      cursor: not-allowed;
    }
  }
`;

export const BlackBorderButton = styled(Button)`
  // border: 1px solid black;
  background: #ffffff;
  border: ${({ isError, disabled }) =>
    isError
      ? '1px solid #EA6E6D'
      : disabled
      ? '1px solid gray'
      : '1px solid black'};

  p {
    font-size: 12px;
    color: ${({ isError, disabled }) =>
      isError ? '#EA6E6D' : disabled ? '#949494' : 'black'};
  }
`;
export const BlackBorderButtonWithWriteAccess = HasRole(
  BlackBorderButton,
  WRITE_ACCESS_AUTH_ROLES
);

export const BlueButton = props => (
  <Button
    color="#FFFFFF"
    fontSize="12px"
    background="linear-gradient(180deg, #11b1d8 0%, #0779af 100%)"
    {...props}
  />
);
export const BlueButtonWithWriteAccess = HasRole(
  BlueButton,
  WRITE_ACCESS_AUTH_ROLES
);
